import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up-down",
  "use": "arrow-up-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-up-down\"><path d=\"M1.318 4.147L4.5.965l3.182 3.182s.354.354 0 .707c-.33.33-.66.04-.703.003a.073.073 0 00-.004-.003L5 2.879V14H4V2.879L2.025 4.854c0 .003-.354.353-.707 0-.354-.354 0-.707 0-.707zM12 1h-1v11.122l-1.975-1.975c0-.003-.354-.353-.707 0-.354.354 0 .707 0 .707l3.182 3.182 3.182-3.182s.354-.354 0-.707c-.33-.33-.66-.04-.703-.004l-.004.004L12 12.122V1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol